module.exports = "<p-dropdown *ngIf=\"items\"\r\n            [style]=\"{width: '100%'}\"\r\n            styleClass=\"form-control\"\r\n            [attr.required]=\"required\"\r\n            [options]=\"options\"\r\n            [(ngModel)]=\"value\"\r\n            [filter]=\"filter\"\r\n            [disabled]=\"disabled\"\r\n            [editable]=\"editable\"\r\n            (ngModelChange)=\"onChange($event)\">\r\n    <ng-template let-item>\r\n        {{item.label}}\r\n    </ng-template>\r\n</p-dropdown>"


//////////////////
// WEBPACK FOOTER
// ./~/@nordpoolgroup/nps-angular-2-common/src/Dropdown/dropdownComponent.html
// module id = 674
// module chunks = 0